import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { User } from '../models/user.model';

@Injectable({ providedIn: 'root' })
export class UserService {
  private readonly localDataUrl = '/assets/data/employees.json';

  constructor(private http: HttpClient) {}

  getUsers(): Observable<User[]> {
    return this.http.get<User[]>(`${environment.apiUrl}?action=list`).pipe(
      map(users => users.map(user => this.withNormalizedImage(user))),
      catchError(() => this.loadLocalUsers())
    );
  }

  /** Busca empleado por slug de URL (ej. `Itzel.Canto`). */
  findBySlug(users: User[], slug: string): User | null {
    const normalized = this.normalizeSlug(slug);
    return users.find(u => this.normalizeSlug(u.slug) === normalized) || null;
  }

  /** Convierte nombre a slug para URL (sin acentos, espacios → puntos). */
  toSlug(name: string): string {
    return this.stripAccents(name).replace(/ /g, '.');
  }

  /** Convierte URLs de Drive a formato directo para <img>. */
  normalizeImageUrl(url: string): string {
    if (!url) {
      return '';
    }

    const fileIdMatch = url.match(/(?:\/d\/|[?&]id=)([a-zA-Z0-9_-]+)/);
    if (fileIdMatch) {
      return `https://lh3.googleusercontent.com/d/${fileIdMatch[1]}=s200`;
    }

    return url;
  }

  private withNormalizedImage(user: User): User {
    return { ...user, image: this.normalizeImageUrl(user.image) };
  }

  private loadLocalUsers(): Observable<User[]> {
    if (!environment.fallbackToLocalData) {
      return of([]);
    }
    return this.http.get<User[]>(this.localDataUrl);
  }

  private normalizeSlug(slug: string): string {
    return this.normalizeName(slug.replace(/\./g, ' '));
  }

  private stripAccents(text: string): string {
    return text.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  }

  normalizeName(name: string): string {
    return this.stripAccents(name).toLowerCase();
  }
}
